import tmhRequest from '@/config/tmhRequest'

export default {
    searchRefundServiceOrder: function (data) {
        return tmhRequest({
            url: '/order/ispa/refundserviceorder/searchrefundserviceorder',
            method: 'post',
            params: data,
        })
    },

    searchRefundServiceOrderCount: function (data) {
        return tmhRequest({
            url: '/order/ispa/refundserviceorder/searchrefundserviceordercount',
            method: 'post',
            data: data,
        })
    },

    searchRefundServiceOrderByPage: function (data) {
        return tmhRequest({
            url: '/order/ispa/refundserviceorder/searchrefundserviceorderbypage',
            method: 'post',
            data: data,
        })
    },

    createRefundServiceOrder: function (data) {
        return tmhRequest({
            url: '/order/ispa/refundserviceorder/createrefundserviceorder',
            method: 'post',
            data: data,
        })
    },

    refundNotify: function (data) {
        return tmhRequest({
            url: '/order/ispa/refundserviceorder/refundnotify',
            method: 'post',
            params: data,
        })
    },

    repairSettlementDetail: function (data) {
        return tmhRequest({
            url: '/order/ispa/refundserviceorder/repairsettlementdetail',
            method: 'post',
            params: data,
        })
    },

    repairEmployeePerformance: function (data) {
        return tmhRequest({
            url: '/order/ispa/refundserviceorder/repairemployeeperformance',
            method: 'post',
            params: data,
        })
    },

    repairRefundServiceOrder: function (data) {
        return tmhRequest({
            url: '/order/refundserviceorder/repairrefundserviceorder',
            method: 'post',
            params: data,
        })
    },
}



// WEBPACK FOOTER //
// ./src/api/ispa/order/refundserviceorder.js